<template>
  <div>
    <div class="placeholder-text load" />
    <div class="placeholder-text load" />
    <div class="placeholder-text load" />
    <div
      class="placeholder-text load"
      style="min-height: 300px"
    />
    <div class="placeholder-text load" />
  </div>
</template>
<script>
export default {
    name: 'CareerPlaceholder',
};
</script>
<style lang="scss">
// check scss/placeholder.scss
</style>
